import { useState } from 'react';
import { getUnreadMessage } from '../../../apis';
import { isObject, SuiteId } from '@libs/shared';

const useUnreadMessage = () => {
    const [hasUnreadMessage, setHasUnreadMessage] = useState<boolean>(false);
    const [unreadMessageStatus, setUnreadMessageStatus] = useState<Record<string, boolean>>({});

    const initUnreadMessage = <T extends string>(types?: T[], suiteId?: SuiteId) => {
        const result = types
            ? getUnreadMessage(types, suiteId).then((response) => {
                  // 如果指定了消息类型，那么只要有任一一种类型有未读状态，就直接认为当前有未读消息
                  const hasUnread = isObject(response)
                      ? Object.values(response).some((unreadStatus) => unreadStatus)
                      : false;
                  return {
                      hasUnread,
                      response
                  };
              })
            : getUnreadMessage().then((response) => {
                  return {
                      hasUnread: response.all,
                      response
                  };
              });
        return result.then(({ hasUnread, response }) => {
            if (hasUnread) {
                setHasUnreadMessage(true);
            }
            setUnreadMessageStatus(response);
            return {
                hasUnreadMessage: hasUnread,
                unreadDetail: response
            };
        });
    };

    return {
        unreadMessageStatus,
        hasUnreadMessage,
        initUnreadMessage
    };
};

export default useUnreadMessage;
